/**
 * © [2023] Conduent, Inc. All rights reserved. Conduent®and Conduent Agile
 * Star®are trademarks of Conduent, Inc. and/or its subsidiaries in the United
 * States and/or other countries.
 */
import React, { useState, useEffect, useCallback } from 'react';
import { useSelector } from 'react-redux';
import { RadioGroupComponent } from '../../../../Display/Claim/component/SelectClaim/SelectClaimSearchComponent';
import { TRANSITION_TYPE_DATA } from '../../OnlineFixes/CreateStubInvoice/utils/constant';
import TransitionDataClaimFiles from './TransitionDataClaimFiles';
import TransitionDataInvoices from './TransitionDataInvoices';
import { setSelectType } from '../store/action';

const TransitionDataHeader = ({
  setErrorMessages,
  setSuccessMessages,
  dispatch,
}) => {
  const selectType = useSelector(
    (state) => state.sharedState?.TransitionData?.selectType
  );

  const [isFullScreenView, setIsFullscreenView] = useState(false);

  const dispatchSetSelectType = useCallback(
    (data) => {
      dispatch(setSelectType(data));
    },
    [selectType]
  );

  useEffect(() => {
    if (!selectType) {
      dispatchSetSelectType(TRANSITION_TYPE_DATA[0].value);
    }
  }, []);

  const onFullScreenChange = (isFullScreen) => {
    setIsFullscreenView(isFullScreen);
  };

  return (
    <>
      <div className='row'>
        <fieldset className='custom-fieldset col-12'>
          {!isFullScreenView && (
            <>
              <legend className='same-font-family'>Select Extract</legend>
              <div className='col-8' data-testid='transition-header'>
                <div className='p-0 t-2 row'>
                  <div className='mui-custom-form col-12 m-0'>
                    <RadioGroupComponent
                      data={TRANSITION_TYPE_DATA}
                      value={selectType}
                      onChange={(_, value) => {
                        dispatchSetSelectType(value);
                        setErrorMessages([]);
                        setSuccessMessages([]);
                      }}
                      data-testid='transition-control'
                    />
                  </div>
                </div>
              </div>
            </>
          )}

          {selectType === TRANSITION_TYPE_DATA[0].value ? (
            <TransitionDataClaimFiles
              setErrorMessages={setErrorMessages}
              setSuccessMessages={setSuccessMessages}
              data-testid='transitionClaim-control'
            />
          ) : (
            <TransitionDataInvoices
              setErrorMessages={setErrorMessages}
              setSuccessMessages={setSuccessMessages}
              data-testid='transitionInvoice-control'
              onFullScreenChange={onFullScreenChange}
            />
          )}
        </fieldset>
      </div>
    </>
  );
};
export default TransitionDataHeader;
